import type { AnalyticsWorkerDto } from "@normax-performance/shared-types";

export interface AttentionSelection {
  /** Top-N worst-performing eligible below-90 workers, worst first. */
  shown: AnalyticsWorkerDto[];
  /** The TRUE total count of eligible below-90 workers, independent of `shown`'s cap — used to decide whether the "Prikaži sve u Analitici" link is shown. */
  totalBelowCount: number;
}

/**
 * "Needs attention" selection (docs/NORMAX_PERFORMANCE_DASHBOARD_SLICE_C_IMPLEMENTATION_REPORT.md
 * §9) — pure, Prisma/React-free so it's directly unit-testable. Deliberately
 * checks `rankingEligible` independently of `zone` — a non-eligible worker
 * is NEVER a "poor performer" by this app's own contract (low sample size
 * is not a performance judgment), so it must never appear here even if its
 * raw zone happens to compute to "below".
 */
export function selectAttentionWorkers(eligibleWorkers: AnalyticsWorkerDto[], limit = 5): AttentionSelection {
  const belowExpected = eligibleWorkers.filter((w) => w.rankingEligible && w.zone?.zone === "below");

  const sorted = [...belowExpected].sort((a, b) => {
    const aPct = a.performancePercentLabel === null ? Infinity : Number(a.performancePercentLabel);
    const bPct = b.performancePercentLabel === null ? Infinity : Number(b.performancePercentLabel);
    return aPct - bPct;
  });

  return { shown: sorted.slice(0, limit), totalBelowCount: belowExpected.length };
}
